<template>
  <div class="no-found" :style="{ 'padding-top': props.marginTop + 'px', 'padding-bottom': props.marginBottom + 'px' }">
    <img src="@/assets/images/noFound.png" alt="" srcset="" />
    <div>{{ emptyText }}</div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  marginTop: {
    type: String,
    default: "160",
  },
  marginBottom: {
    type: String,
    default: "0",
  },
  emptyText: {
    type: String,
    default: "暂无数据",
  },
});
</script>
